import { ValidationService } from './validation';
import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class TabsService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Tabs';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'tab/0/tab/tab1', 'title': 'Footer tab - text', 'theme': 'layout1' },
      { 'url': 'tab/1/tab/tab4', 'title': 'Footer tab - icons', 'theme': 'layout2' },
      { 'url': 'tab/2/tab/tab7', 'title': 'Header tab - text', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.charAt(0).toUpperCase() +
      menuItem.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForTab1 = (): any => {
    return {
      'items': [
        {
          'id': 1,
          'title': 'Grant Marshall',
          'avatar': 'assets/imgs/avatar/17.jpg',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image1': 'assets/imgs/background/1.jpg',
          'image2': 'assets/imgs/background/2.jpg',
          'image3': 'assets/imgs/background/3.jpg',
          'iconLike': 'thumbs-up',
          'iconComments': 'chatbubbles',
          'iconShare': 'arrow-redo',
          'buttonLike': '326',
          'buttonComments': '132',
          'buttonShare': 'Share'
        },
        {
          'id': 2,
          'title': 'Jessica Miles',
          'avatar': 'assets/imgs/avatar/18.jpg',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image1': 'assets/imgs/background/2.jpg',
          'image2': 'assets/imgs/background/4.jpg',
          'image3': 'assets/imgs/background/5.jpg',
          'iconLike': 'thumbs-up',
          'iconComments': 'chatbubbles',
          'iconShare': 'arrow-redo',
          'buttonLike': '326',
          'buttonComments': '132',
          'buttonShare': 'Share'
        },
        {
          'id': 3,
          'title': 'Natasha Gamble',
          'avatar': 'assets/imgs/avatar/19.jpg',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image1': 'assets/imgs/background/6.jpg',
          'image2': 'assets/imgs/background/7.jpg',
          'image3': 'assets/imgs/background/8.jpg',
          'iconLike': 'thumbs-up',
          'iconComments': 'chatbubbles',
          'iconShare': 'arrow-redo',
          'buttonLike': '326',
          'buttonComments': '132',
          'buttonShare': 'Share'
        },
        {
          'id': 4,
          'title': 'Josefa Gardner',
          'avatar': 'assets/imgs/avatar/20.jpg',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image1': 'assets/imgs/background/9.jpg',
          'image2': 'assets/imgs/background/1.jpg',
          'image3': 'assets/imgs/background/3.jpg',
          'iconLike': 'thumbs-up',
          'iconComments': 'chatbubbles',
          'iconShare': 'arrow-redo',
          'buttonLike': '326',
          'buttonComments': '132',
          'buttonShare': 'Share'
        },
        {
          'id': 5,
          'title': 'Guerrero Woodard',
          'avatar': 'assets/imgs/avatar/21.jpg',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image1': 'assets/imgs/background/8.jpg',
          'image2': 'assets/imgs/background/4.jpg',
          'image3': 'assets/imgs/background/3.jpg',
          'iconLike': 'thumbs-up',
          'iconComments': 'chatbubbles',
          'iconShare': 'arrow-redo',
          'buttonLike': '326',
          'buttonComments': '132',
          'buttonShare': 'Share'
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForTab2 = (): any => {
    return {
      'headerTitle': "Followers",
      'items': [
        {
          'id': 1,
          'title': 'Isaac Reid',
          'subtitle': 'from Brogan ',
          'avatar': 'assets/imgs/avatar/24.jpg'
        },
        {
          'id': 2,
          'title': 'Jason Graham',
          'subtitle': 'from Rehrersburg',
          'avatar': 'assets/imgs/avatar/23.jpg'
        },
        {
          'id': 3,
          'title': 'Abigail Ross',
          'subtitle': 'from Durham ',
          'avatar': 'assets/imgs/avatar/22.jpg'
        },
        {
          'id': 4,
          'title': 'Justin Rutherford',
          'subtitle': 'from Callaghan',
          'avatar': 'assets/imgs/avatar/21.jpg'
        },
        {
          'id': 5,
          'title': 'Nicholas Henderson',
          'subtitle': 'from Manitou',
          'avatar': 'assets/imgs/avatar/20.jpg'
        },
        {
          'id': 6,
          'title': 'Elizabeth Mackenzie',
          'subtitle': 'from Weedville',
          'avatar': 'assets/imgs/avatar/19.jpg'
        },
        {
          'id': 7,
          'title': 'Melanie Ferguson',
          'subtitle': 'from Curtice',
          'avatar': 'assets/imgs/avatar/18.jpg'
        },
        {
          'id': 8,
          'title': 'Fiona Kelly',
          'subtitle': 'from Barronett',
          'avatar': 'assets/imgs/avatar/17.jpg'
        },
        {
          'id': 9,
          'title': 'Nicholas King',
          'subtitle': 'from Urie',
          'avatar': 'assets/imgs/avatar/24.jpg'
        },
        {
          'id': 10,
          'title': 'Victoria Mitchell',
          'subtitle': 'from Blackgum',
          'avatar': 'assets/imgs/avatar/23.jpg'
        },
        {
          'id': 11,
          'title': 'Sophie Lyman',
          'subtitle': 'from Williston',
          'avatar': 'assets/imgs/avatar/21.jpg'
        },
        {
          'id': 12,
          'title': 'Carl Ince',
          'subtitle': 'from Norvelt',
          'avatar': 'assets/imgs/avatar/22.jpg'
        },
        {
          'id': 13,
          'title': 'Michelle Slater',
          'subtitle': 'from Maxville',
          'avatar': 'assets/imgs/avatar/20.jpg'
        },
        {
          'id': 14,
          'title': 'Ryan Mathis',
          'subtitle': 'from Bannock',
          'avatar': 'assets/imgs/avatar/19.jpg'
        },
        {
          'id': 15,
          'title': 'Julia Grant',
          'subtitle': 'from Nutrioso',
          'avatar': 'assets/imgs/avatar/18.jpg'
        },
        {
          'id': 16,
          'title': 'Hannah Martin',
          'subtitle': 'from Bluetown',
          'avatar': 'assets/imgs/avatar/17.jpg'
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForTab3 = (): any => {
    return {
      'allComments': '2121 Comments',
      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/avatar/17.jpg',
          'title': 'Erica Romaguera',
          'time': '18 August 2018 at 12:20pm',
          'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 2,
          'image': 'assets/imgs/avatar/18.jpg',
          'title': 'Caleigh Jerde',
          'time': '18 August 2018 at 8:13pm',
          'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 3,
          'image': 'assets/imgs/avatar/19.jpg',
          'title': 'Lucas Schultz',
          'time': '18 August 2018 at 5:22pm',
          'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 4,
          'image': 'assets/imgs/avatar/20.jpg',
          'title': 'Carole Marvin',
          'time': '18 August 2018 at 7:36am',
          'description': `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.`,
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 5,
          'image': 'assets/imgs/avatar/23.jpg',
          'title': 'Doriana Feeney',
          'time': '18 August 2018 at 5:28am',
          'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 6,
          'image': 'assets/imgs/avatar/21.jpg',
          'title': 'Nia Gutkowski',
          'time': '18 August 2018 at 11:27pm',
          'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        }
      ]
    };
  }

  //* Data Set for page 4
  getDataForTab4 = (): any => {
    return {
      'items': [
          {
              'id': 1,
              "title": "New York Hilton Midtown",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/1.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          },
          {
              'id': 2,
              "title": "New York Marriott Marquis",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/2.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
              'iconFavorite': 'heart',
          },
          {
              'id': 3,
              "title": "Grand Hyatt New York",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/3.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          },
          {
              'id': 4,
              "title": "The Roosevelt Hotel",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/4.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          },
          {
              'id': 5,
              "title": "Kennedy Fried Chicken",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/9.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          },
          {
              'id': 6,
              "title": "PKorilla BBQ",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/10.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          },
          {
              'id': 7,
              "title": "BurritoVille",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/11.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          },
          {
              'id': 8,
              "title": "Mo Gridder's",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/12.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location",
          }
      ]
    };
  }

  //* Data Set for page 5
  getDataForTab5 = (): any => {
    return {
      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/avatar/24.jpg',
          'title': 'Erica Romaguera',
          'time': '18 August 2018 at 12:20pm',
          'description': 'If you could have any kind of pet, what would you choose?'
        },
        {
          'id': 2,
          'image': 'assets/imgs/avatar/18.jpg',
          'title': 'Caleigh Jerde',
          'time': '18 August 2018 at 8:13pm',
          'description': 'If you could learn any language, what would you choose?'
        },
        {
          'id': 3,
          'image': 'assets/imgs/avatar/19.jpg',
          'title': 'Lucas Schultz',
          'time': '18 August 2018 at 5:22pm',
          'description': 'Life is about making an impact, not making an income.'
        },
        {
          'id': 4,
          'image': 'assets/imgs/avatar/20.jpg',
          'title': 'Carole Marvin',
          'time': '18 August 2018 at 7:36am',
          'description': `I’ve learned that people will forget what you said,
               people will forget what you did, but people will never forget how you made them feel`
        },
        {
          'id': 5,
          'image': 'assets/imgs/avatar/21.jpg',
          'title': 'Doriana Feeney',
          'time': '18 August 2018 at 5:28am',
          'description': 'Definiteness of purpose is the starting point of all achievement.'
        },
        {
          'id': 6,
          'image': 'assets/imgs/avatar/22.jpg',
          'title': 'Nia Gutkowski',
          'time': '18 August 2018 at 11:27pm',
          'description': 'Life is what happens to you while you’re busy making other plans'
        }
      ]
    };
  }

  //* Data Set for page 6
  getDataForTab6 = (): any => {
    return {
      'yourName': 'Your Name',
      'title': 'Title',
      'description': 'Enter a description',
      'button': ' Write Comment'
    };
  }

  //* Data Set for page 7
  getDataForTab7 = (): any => {
    return {
      'items': [
        {
          'id': 1,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/20.jpg',
          'title': '45 Park Lane',
          'subtitle': '2 beds',
          'price': '$ 20 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/23.jpg',
          'title': 'Encore Macau',
          'subtitle': '3 beds',
          'price': '$ 700 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/21.jpg',
          'title': 'Bulgari Hotel London',
          'subtitle': '2 beds',
          'price': '$ 300 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/22.jpg',
          'title': 'Belmond El Encanto',
          'subtitle': '1 beds',
          'price': '$ 500 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/24.jpg',
          'title': 'The Allocationa Gstaad',
          'subtitle': '3 beds',
          'price': '$ 400 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  //* Data Set for page 8
  getDataForTab8 = (): any => {
    return {
      'items': [
        {
          'id': 1,
          'title': 'Isaac Reid',
          'subtitle': 'from Brogan ',
          'avatar': 'assets/imgs/avatar/24.jpg'
        },
        {
          'id': 2,
          'title': 'Jason Graham',
          'subtitle': 'from Rehrersburg',
          'avatar': 'assets/imgs/avatar/23.jpg'
        },
        {
          'id': 3,
          'title': 'Abigail Ross',
          'subtitle': 'from Durham ',
          'avatar': 'assets/imgs/avatar/22.jpg'
        },
        {
          'id': 4,
          'title': 'Justin Rutherford',
          'subtitle': 'from Callaghan',
          'avatar': 'assets/imgs/avatar/21.jpg'
        },
        {
          'id': 5,
          'title': 'Nicholas Henderson',
          'subtitle': 'from Manitou',
          'avatar': 'assets/imgs/avatar/20.jpg'
        },
        {
          'id': 6,
          'title': 'Elizabeth Mackenzie',
          'subtitle': 'from Weedville',
          'avatar': 'assets/imgs/avatar/19.jpg'
        },
        {
          'id': 7,
          'title': 'Melanie Ferguson',
          'subtitle': 'from Curtice',
          'avatar': 'assets/imgs/avatar/18.jpg'
        },
        {
          'id': 8,
          'title': 'Fiona Kelly',
          'subtitle': 'from Barronett',
          'avatar': 'assets/imgs/avatar/17.jpg'
        },
        {
          'id': 9,
          'title': 'Nicholas King',
          'subtitle': 'from Urie',
          'avatar': 'assets/imgs/avatar/24.jpg'
        },
        {
          'id': 10,
          'title': 'Victoria Mitchell',
          'subtitle': 'from Blackgum',
          'avatar': 'assets/imgs/avatar/23.jpg'
        },
        {
          'id': 11,
          'title': 'Sophie Lyman',
          'subtitle': 'from Williston',
          'avatar': 'assets/imgs/avatar/21.jpg'
        },
        {
          'id': 12,
          'title': 'Carl Ince',
          'subtitle': 'from Norvelt',
          'avatar': 'assets/imgs/avatar/22.jpg'
        },
        {
          'id': 13,
          'title': 'Michelle Slater',
          'subtitle': 'from Maxville',
          'avatar': 'assets/imgs/avatar/20.jpg'
        },
        {
          'id': 14,
          'title': 'Ryan Mathis',
          'subtitle': 'from Bannock',
          'avatar': 'assets/imgs/avatar/19.jpg'
        },
        {
          'id': 15,
          'title': 'Julia Grant',
          'subtitle': 'from Nutrioso',
          'avatar': 'assets/imgs/avatar/18.jpg'
        },
        {
          'id': 16,
          'title': 'Hannah Martin',
          'subtitle': 'from Bluetown',
          'avatar': 'assets/imgs/avatar/17.jpg'
        }
      ]
    };
  }

  //* Data Set for page 9
  getDataForTab9 = (): any => {
    return {
      'items': [
          {
              'id': 1,
              'title': 'Fortuitu ad aeroportus',
              'date': `Jun 24, 2019`,
              'image': 'assets/imgs/background/1.jpg',
          },
          {
              'id': 2,
              'title': 'Hoc est exortum',
              'date': `Jun 24, 2019`,
              'image': 'assets/imgs/background/2.jpg',
          },
          {
              'id': 3,
              'title': 'Communications moderatoris',
              'date': `Jun 24, 2019`,
              'image': 'assets/imgs/background/3.jpg',
          },
          {
              'id': 4,
              'title': 'Tabulas scripto munus agere providere',
              'date': `Jun 24, 2019`,
              'image': 'assets/imgs/background/4.jpg',
          },
          {
              'id': 5,
              'title': 'In outpatient nuntiatum ministerium',
              'date': `Jun 24, 2019`,
              'image': 'assets/imgs/background/1.jpg',
          }
      ]
    };
  }

  load(item: string): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('tab/' + item)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
